import ItemWrapper from "./ItemWrapper"
import { useEffect, useState } from "react"
import { getOrganizationDetail } from "pages/organization/organization.services"
import { OrganizationDetail } from "pages/organization/organization.type"
import { OrganizationIconCard } from "components/OrganizationIconCard"
import { TippyCustomzie } from "components/TippyCustomzie"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"
import ActionItem from "pages/projects/molecules/ActionItem"
import { useBoolean, useWindowSize } from "helpers/hooks"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import { useSelector } from "react-redux"
import { RootState } from "stores/configureStore"

interface Props {
  organizationId: string
}
export const OrganizationDetailCard = (props: Props) => {
  const { isMobile } = useWindowSize()
  const { organizationId } = props
  const userInfo = useSelector((state: RootState) => state.userInfo)
  const isOwner =
    userInfo.organizations?.find((el) => el.id === organizationId)?.type ===
    "OWNER"
  const [organizationDetail, setOrganizationDetail] =
    useState<OrganizationDetail | null>(null)
  const showAction = useBoolean(false)

  useEffect(() => {
    getOrganizationDetail(organizationId).then((response) => {
      setOrganizationDetail(response)
    })
  }, [organizationId])
  if (!organizationDetail) return null

  return (
    <ItemWrapper className="max-w-auto md:w-auto flex-1">
      <div className="flex items-start justify-between gap-x-[16px] w-full">
        <OrganizationIconCard
          bg={organizationDetail.profile?.background_color || ""}
          name={organizationDetail.name}
          zIndex={1}
          icon={organizationDetail.profile?.logo_url || ""}
          organizationId={organizationDetail.id}
          className="rounded-[8px] flex items-center justify-center min-w-[44px] min-h-[44px]"
        />
        <div className="flex flex-col justify-between h-[44px] flex-1">
          <p className="text-sm font-semibold">Workspace Detail</p>
          <p className="text-sm font-semibold">{`${organizationDetail.code} - ${organizationDetail.name}`}</p>
        </div>
        <div>
          {isOwner && !isMobile ? (
            <TippyCustomzie
              containerClass="component-card-menu"
              placement="bottom-end"
              interactive
              arrow={false}
              animation="scale"
              visible={showAction.value}
              onClickOutside={() => showAction.setValue(false)}
              content={
                <div
                  style={{
                    background: "#222222",
                    borderRadius: 4,
                    paddingTop: 8,
                    paddingBottom: 8,
                    width: 80,
                  }}
                >
                  <ActionItem
                    title="Edit"
                    onClick={() => {
                      showAction.setValue(false)
                      pushTo(PATH.organizationEdit)
                    }}
                  />
                </div>
              }
              allowHTML
            >
              <div
                className="flex items-center"
                onClick={() => showAction.setValue(true)}
              >
                <ActionIconHistory
                  icon="three-dots"
                  tooltip="Action"
                  styleIcon={{
                    marginRight: 0,
                  }}
                />
              </div>
            </TippyCustomzie>
          ) : null}
        </div>
      </div>

      <div className="flex flex-col mt-[24px]">
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Workspace Owner</p>
          <p className="text-sm font-semibold">{organizationDetail.email}</p>
        </div>
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Address</p>
          <p className="text-sm font-semibold">
            {organizationDetail.profile?.address || "N/A"}
          </p>
        </div>
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Postal Code</p>
          <p className="text-sm font-semibold">
            {organizationDetail.profile?.postal_code || "N/A"}
          </p>
        </div>
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Contact</p>
          <p className="text-sm font-semibold">
            {organizationDetail.profile?.phone_number || "N/A"}
          </p>
        </div>
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Website</p>
          {organizationDetail.profile?.website ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={organizationDetail.profile?.website}
              className="text-sm font-semibold text-blue underline"
            >
              {organizationDetail.profile?.website}
            </a>
          ) : (
            <p className="text-sm font-semibold">{"N/A"}</p>
          )}
        </div>
        <div className="flex flex-col mb-[12px]">
          <p className="text-xs font-medium">Description</p>
          <p className="text-sm font-semibold">
            {organizationDetail.profile?.description || "N/A"}
          </p>
        </div>
      </div>
    </ItemWrapper>
  )
}
